{
    "account": "கணக்கு",
    "add_bookmark": "புக்மார்க்கு செய்தி",
    "add_date": "ஒரு தேதியைச் சேர்க்கவும்",
    "ago": "{{duration}} முன்பு",
    "api_key": "பநிஇ விசை",
    "are_you_sure": "நீ சொல்வது உறுதியா?",
    "ask_delete_message": "இந்த செய்தியை நீக்கவா?",
    "audio_not_ready": "ஆடியோ இன்னும் தயாராக இல்லை.",
    "bookmark_added": "செய்தி புக்மார்க்கு செய்யப்பட்டது.",
    "bookmark_removed": "செய்தி புக்மார்க்கு நீக்கப்பட்டது.",
    "bookmarks": "புக்மார்க்குகள்",
    "cancel_write": "புதிய செய்தியை எழுதுவதை ரத்து செய்ய விரும்புகிறீர்களா?",
    "cancel": "ரத்துசெய்",
    "changed_group_name": "குழுவின் பெயரை மாற்றியது",
    "confirm_password_placeholder": "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    "connect": "இணைப்பு",
    "create_a_group": "ஒரு குழுவை உருவாக்கவும்",
    "create_the_group": "குழுவை உருவாக்கவும்",
    "daily": "நாள்தோறும்",
    "default_group": "இயல்புநிலை குழு",
    "delete": "அழி",
    "destroy_account_explain": "உங்கள் கணக்கை நீக்கியதும், திரும்பிச் செல்வதில்லை. தயவுசெய்து உறுதியாக இருங்கள்.",
    "destroy_account": "உங்கள் கணக்கை நீக்கு",
    "edit": "தொகு",
    "email_input": "உங்கள் மின்னஞ்சல் முகவரியை இங்கே நிரப்பவும்",
    "email": "மின்னஞ்சல்",
    "empty_message": "செய்தி காலியாக உள்ளது மற்றும் அனுப்ப முடியாது.",
    "error_new_message": "உங்கள் செய்தியை அனுப்பும்போது பிழை ஏற்பட்டது.",
    "error_upload": "பதிவேற்றத்தின் போது பிழை ஏற்பட்டது",
    "error": "பிழை ஏற்பட்டது",
    "forgot_password": "உங்கள் கடவுச்சொல்லை மறந்து விட்டீர்களா?",
    "group_left": "நீங்கள் குழுவை விட்டு வெளியேறினீர்கள்.",
    "group_share_choice": "இந்த செய்தியை எந்த குழுவிற்கு அனுப்ப விரும்புகிறீர்கள்?",
    "groups": "குழுக்கள்",
    "group_updated": "குழு புதுப்பிக்கப்பட்டது.",
    "has_commented_on": "கருத்து தெரிவித்துள்ளது",
    "has_joined": "சேர்ந்துள்ளார்",
    "has_left": "போய் விட்டது",
    "has_posted_in": "இடுகையிடப்பட்டுள்ளது",
    "hourly": "மணிநேரத்திற்கு",
    "Invalid login/password": "தவறான உள்நுழைவு மற்றும்/அல்லது கடவுச்சொல்",
    "invitation_link": "அழைப்பிதழ் இணைப்பு",
    "invitation_welcome": "சூசாமில் வரவேற்கிறோம். குழுவில் சேருவதற்கு முன் பதிவுபெறுக.",
    "in": "இல்",
    "just_now": "இப்போது",
    "lang": "மொழி",
    "login_input": "உள்நுழைவைத் தேர்வுசெய்க",
    "login_placeholder": "மின்னஞ்சல்",
    "login": "புகுபதிகை",
    "logout": "விடுபதிகை",
    "mark_all_as_read": "அனைத்தையும் வாசிக்கப்பட்டதாக அடையாளமிடு",
    "monthly": "மாதாந்திர",
    "multiple_photos_upload": "பிழை ஏற்பட்டது. படங்களை ஒவ்வொன்றாக பதிவேற்ற முயற்சிக்கவும் (இது சில உலாவிகளில் நிகழலாம்)",
    "name_input": "ஒரு பெயரைத் தேர்வுசெய்க",
    "name": "பெயர்",
    "new_password_placeholder": "புதிய கடவுச்சொல்",
    "next_coms": "அடுத்த கருத்துகளைப் பார்க்கவும்",
    "none": "எதுவுமில்லை",
    "notification_emails_stopped": "மின்னஞ்சல் அறிவிப்புகள் நிறுத்தப்பட்டன!",
    "notification_emails": "மின்னஞ்சல் அறிவிப்புகள்",
    "notifications": "அறிவிப்புகள்",
    "parent_message": "பெற்றோர் செய்தி",
    "password_input": "புதிய கடவுச்சொல்லை இங்கே எழுதுங்கள்",
    "password_placeholder": "கடவுச்சொல்",
    "password_reset_mail_sent": "உங்கள் இன்பாக்சில் கடவுச்சொல் மீட்டமைப்பு மின்னஞ்சலைத் தேடுங்கள்.",
    "passwords_dont_match": "கடவுச்சொற்கள் பொருந்தவில்லை",
    "password": "கடவுச்சொல்",
    "previous_coms": "முந்தைய கருத்துகளைப் பார்க்கவும்",
    "public_link": "பொது இணைப்பு",
    "publish_in_group": "குழுவில் வெளியிடுங்கள்",
    "quit_group": "குழுவை விட்டு விடுங்கள்",
    "remove_bookmark": "புத்தகமரம் செய்தி",
    "replies_one": "{{count}} பதில்",
    "replies_other": "{{count}} பதில்கள்",
    "reply": "பதில்",
    "reset_api_key": "பநிஇ விசையை மீட்டமைக்கவும் (நீங்கள் துண்டிக்கப்படுவீர்கள்)",
    "reset_invitation_link": "அழைப்பிதழ் இணைப்பை மீட்டமைக்கவும்",
    "reset_password_title": "உங்கள் கடவுச்சொல்லை மீட்டமைக்க",
    "save_changes": "மாற்றங்களை சேமியுங்கள்",
    "search_in_group": "இந்த குழுவில் தேடுங்கள்",
    "search_without_result": "உங்கள் தேடல் எந்த செய்திக்கும் பொருந்தவில்லை.",
    "settings_updated": "உங்கள் அமைப்புகள் புதுப்பிக்கப்பட்டன",
    "settings": "அமைப்புகள்",
    "share_message": "செய்தியைப் பகிரவும்",
    "signup": "பதிவு செய்க",
    "submit": "சமர்ப்பிக்கவும்",
    "text_placeholder": "உங்கள் செய்தியை இங்கே எழுதுங்கள்",
    "the_message_from": "இருந்து செய்தி",
    "title_placeholder": "உங்கள் செய்தியின் தலைப்பு (விரும்பினால்)",
    "to": "பெறுநர்",
    "upload_audio": "ஆடியோ கோப்பைச் சேர்க்கவும்.",
    "upload_image": "புகைப்படங்களைச் சேர்க்கவும்",
    "upload_music": "இசையைச் சேர்க்கவும்",
    "upload_pdf": "PDF ஐச் சேர்க்கவும்",
    "upload_video": "வீடியோவைச் சேர்க்கவும்",
    "User not found": "பயனர் கண்டுபிடிக்கப்படவில்லை",
    "users": "பயனர்கள்",
    "video_not_ready": "வீடியோ இன்னும் தயாராக இல்லை.",
    "weekly": "வாராந்திர"
}
